
import { formatImageSrc } from '@xd-rocket/utils/base';

export default {
  components: {
    QrcodeVue: () => import('qrcode.vue'),
  },
  props: {
    background: {
      type: String,
      default: '',
    },
  },
  data() {
    let srcInfo = formatImageSrc(this.background);
    let styles = {};
    if (srcInfo.src) {
      styles['--auto-adaptive-bg'] = `url(${srcInfo.src})`;
      if (srcInfo.isValid) {
        styles['--auto-adaptive-bg-1x'] = `url(${srcInfo.src_1x})`;
      }
    }
    return {
      qrCode: {
        value: window?.location?.href,
        level: window?.location?.href.length > 100 ? 'L' : 'M',
        foreground: '#00D9C5',
        background: '#ffffff',
      },
      styles,
    };
  },
};
